<ng-container
  class="ticket-list"
  *ngIf="pagedTickets$ | glxyAsyncStatus | async as ticketList"
  [ngSwitch]="ticketList.status"
>
  <ng-container *ngSwitchCase="'loading'">
    <glxy-loading-spinner></glxy-loading-spinner>
  </ng-container>
  <ng-container *ngSwitchCase="'error'">
    <ng-container *ngTemplateOutlet="Error"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'loaded'">
    <glxy-loading-spinner *ngIf="isLoading$ | async"></glxy-loading-spinner>
    <ng-container *ngIf="(isLoading$ | async) === false">
      <glxy-label class="ticket-type">{{ title }} ({{ ticketList.value.total }})</glxy-label>
      <ng-container *ngIf="ticketList.value.total === 0">
        <ng-container *ngTemplateOutlet="NoTickets"></ng-container>
      </ng-container>
      <ng-container *ngIf="ticketList.value.total > 0">
        <div class="ticket-card" *ngFor="let ticketInfo of ticketList.value.tickets">
          <inbox-ticket-card [ticketCardInfo]="ticketInfo"></inbox-ticket-card>
        </div>
      </ng-container>
      <div class="button-more" *ngIf="ticketList.value.continue">
        <a (click)="loadClosed()">{{ 'INBOX.TICKETS.LOAD_MORE' | translate }}</a>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #NoTickets>
    <mat-card class="ticket-card" appearance="outlined">
      <mat-card-content>
        <mat-card-subtitle>
          {{ 'INBOX.TICKETS.NO_TICKETS' | translate : { status: statusName } }}
        </mat-card-subtitle>
      </mat-card-content>
    </mat-card>
  </ng-template>
  <ng-template #Error>
    <glxy-alert type="warning">
      {{ 'INBOX.TICKETS.ERROR_TICKETS' | translate : { status: statusName } }}
    </glxy-alert>
  </ng-template>
</ng-container>
